import { render, staticRenderFns } from "./FollowupCell.vue?vue&type=template&id=7c1ef343&scoped=true"
import script from "./FollowupCell.vue?vue&type=script&lang=js"
export * from "./FollowupCell.vue?vue&type=script&lang=js"
import style0 from "./FollowupCell.vue?vue&type=style&index=0&id=7c1ef343&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1ef343",
  null
  
)

export default component.exports